import { propClassName } from '@/styles/TextField';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';

export interface TextFieldCaptionProps extends ComponentProps<'span'> {
  colors?: ClassNameProp<'primary'>;
  size?: ClassNameProp<'default' | 'alternative'>;
  variant?: ClassNameProp<'default' | 'alternative'>;
}

export const TextFieldCaptionComponent: Component<TextFieldCaptionProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const sizeClassName = propClassName('caption_size', size, 'default');
  const colorsClassName = propClassName('caption_colors', colors, 'primary');
  const variantClassName = propClassName('caption_variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <span className={componentClassName} {...props}>
      {children}
    </span>
  );
};
